export enum DiagnosticJobState {
  NONE = "NONE",
  RUNNING = "RUNNING",
  DONE = "DONE",
  ERROR = "ERROR"
}
